import { StyledModal } from '@app/components/modal/Modal';
import type { ChannelPartner } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { PartnerForm } from './PartnerForm';
import useChannelPartnerActions from '@app/hooks/channelPartners/useChannelPartnerActions';

export type PartnerEditModalProps = ModalProps & {
    title?: string;
    data?: ChannelPartner;
    showFooter?: boolean;
};

export const PartnerEditModal = ({
    title = 'Edit Channel Partner',
    data,
    onOk,
    ...props
}: PartnerEditModalProps) => {
    const { editChannelPartner } = useChannelPartnerActions();

    return (
        <StyledModal title={title} maskClosable={false} width={680} footer={null} {...props}>
            <PartnerForm
                id="channel-partner-edit"
                data={data}
                isEdit={true}
                onCancel={props.onCancel}
                loading={editChannelPartner.isPending}
                // showFooter={false}
                onSubmit={(values) => {
                    const userId = data?.id?.toString() || '';
                    const formData = {
                        ...values,
                        id: userId,
                    };
                    editChannelPartner.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
